import React from 'react';
import './ResetPassword.scss';
import { TwButton, TwButtonType } from '../../components/TwButtons/TwButtons';
import { TwTitle, TwTitleColor, TwTitleType } from '../../components/TwTitles/TwTitles';
import { ReactComponent as TruckbaseLogo } from '../../assets/truckbase-logo.svg';
import { ReactComponent as TbLogo } from '../../assets/tb-logo.svg';
import { ReactComponent as SuccessImage } from '../../assets/success.svg';
import { useNavigate } from 'react-router-dom';

const ResetPassword: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  const backToSignIn = (): void => {
    navigate('/signin');
  };

  return (
    <>
      <div className="reset-password__wrapper tid-reset-password__wrapper">
        <div className="reset-password__form-section">
          <div className="reset-password__form-logo">
            <TbLogo />
          </div>

          <div className="reset-password__success-image">
            <SuccessImage />
          </div>
          <div className="reset-password__title">
            <TwTitle type={TwTitleType.secondary} text="Sent! Check your email" />
          </div>

          <div className="reset-password__inputs-container">
            <span className="reset-password__instructions tid-reset-password__instructions">
              Head over to your mailbox to get your reset link and create your brand new password.
            </span>

            <div className="reset-password__action-container">
              <div className="reset-password__submit-button">
                <TwButton
                  label="Back to sign in"
                  disabled={false}
                  type={TwButtonType.primary}
                  action={backToSignIn}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="reset-password__photo-section">
          <div className="reset-password__logo-container">
            <TruckbaseLogo className="reset-password__logo" />
          </div>
          <TwTitle type={TwTitleType.primary} text="More trucking." />
          <TwTitle type={TwTitleType.primary} color={TwTitleColor.red} text="Less paperwork." />
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
